module.exports = __webpack_public_path__ + "img/banner-mobile-1024x674.c96699d.jpeg";